import React from "react"

import { useTranslation } from "react-i18next"

import { DailyActivation } from "services/bonus/type"

import { formatFiatCurrency } from "util/formatter"

interface Props {
  dailyActivations: DailyActivation[]
}

export const DailyActivationsChart = ({ dailyActivations }: Props) => {
  const { t } = useTranslation("translation", { useSuspense: false })
  const maxDailyCount = Math.max(...dailyActivations.map((d) => d.count), 1)

  return (
    <div className="rounded-3xl border p-6 border-[rgba(0,0,0,0.05)] bg-white backdrop-blur-[9px] shadow-[0px_3px_6px_0px_rgba(192,192,192,0.6)] dark:border-[rgba(255,255,255,0.1)] dark:bg-[rgba(255,255,255,0.04)] dark:backdrop-blur-md dark:shadow-none">
      <h4 className="font-semibold mb-4 text-[rgba(6,7,21,1)] dark:text-white">{t("bonus2.analytics.dailyActivations")}</h4>
      <div className="h-48 flex items-end gap-1">
        {dailyActivations.map((day, index) => (
          <div key={index} className="flex-1 flex flex-col items-center group relative">
            <div
              className="w-full bg-primary rounded-t transition-all hover:opacity-80"
              style={{ height: `${(day.count / maxDailyCount) * 100}%`, minHeight: day.count > 0 ? "4px" : "0px" }}
            />
            <div className="absolute bottom-full mb-2 hidden group-hover:block text-xs rounded px-2 py-1 whitespace-nowrap z-10 bg-gray-800 text-white dark:bg-black">
              {day.date}: {day.count} activations
              <br />
              Value: {formatFiatCurrency(day.value)}
            </div>
          </div>
        ))}
      </div>
      <div className="flex justify-between text-xs mt-2 text-gray-400 dark:text-gray-500">
        <span>{dailyActivations[0]?.date}</span>
        <span>{dailyActivations[dailyActivations.length - 1]?.date}</span>
      </div>
    </div>
  )
}
